import script from "./OrderSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderSelect.vue?vue&type=script&lang=ts&setup=true"

import "./OrderSelect.vue?vue&type=style&index=0&id=44f5b63e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44f5b63e"]])

export default __exports__